import React, { FC } from 'react';
import styled from '@emotion/styled';
import css from '@styled-system/css';
import PropTypes from 'prop-types';
import { variant } from 'styled-system';

import { Glyph } from '../../../../iconography/Glyph';
import { Flex } from '../../../../layouts';
import {
  DrawerHeaderCloseIconProps,
  IconContainerProps,
  Placement,
} from './types';

const IconContainer = styled(Flex)<IconContainerProps>(
  css({
    top: '0',
  }),
  variant({
    prop: 'placement',
    variants: {
      start: {
        'html[dir=ltr] &': {
          left: '0',
        },
        'html[dir=rtl] &': {
          right: '0',
        },
      },
      end: {
        'html[dir=ltr] &': {
          right: '0',
        },
        'html[dir=rtl] &': {
          left: '0',
        },
      },
    },
  })
);

const DrawerIconContainer: FC<IconContainerProps> = ({
  placement,
  ariaLabel,
  onClick,
  children,
}) => {
  return (
    <IconContainer
      alignItems="center"
      cursor="pointer"
      position="absolute"
      role="button"
      aria-pressed="false"
      aria-label={ariaLabel}
      placement={placement}
      onClick={onClick}
    >
      {children}
    </IconContainer>
  );
};

const DrawerHeaderCloseIcon: FC<DrawerHeaderCloseIconProps> = ({
  placement = 'start',
  color = 'primary.50',
  ariaLabel,
  onClick = () => {},
  sx,
}) => {
  return (
    <DrawerIconContainer
      placement={placement}
      ariaLabel={ariaLabel}
      onClick={onClick}
    >
      <Glyph
        category="UIActions"
        color={color}
        name="Clear"
        size="medium"
        sx={sx}
      />
    </DrawerIconContainer>
  );
};

const placements: Array<Placement> = ['start', 'end'];

DrawerHeaderCloseIcon.propTypes = {
  placement: PropTypes.oneOf(placements),
  ariaLabel: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
};
export { DrawerHeaderCloseIcon };
